module.exports = __webpack_public_path__ + "static/media/danske-bank.f0fb6003.svg";